module.exports = __webpack_public_path__ + "static/media/icon.3724592c.svg";